import styled from 'styled-components';

export const CompetitionPatronitedPatrocin = styled.h4`
  font-size: 12px;
  font-weight: 500;
  margin: 5px 0 0 0px;
  color: #95a0a1;
`;